import { useState } from 'react';
import axios from 'axios';

const cashedUrls = {};

export const useLoadImages = () => {
  const [isPending, setIsPending] = useState(false);

  const delQuery = (str) => str.split('?')[0];

  return {
    loadImages: async (urls) => {
      setIsPending(true);

      const promises = urls.map((url) => {
        const formattedStr = delQuery(url);

        if (cashedUrls[formattedStr]) return Promise.resolve(cashedUrls[formattedStr]);

        return axios.get(url, { responseType: 'blob' }).catch(() => url);
      });

      const data = await Promise.all(promises);

      const returnedData = data.map((data) => {
        if (typeof data === 'string') return data;

        const url = URL.createObjectURL(data.data);

        const formattedString = delQuery(data.config.url);

        return (cashedUrls[formattedString] = url);
      });

      setIsPending(false);

      return returnedData;
    },
    isPending,
  };
};
